export const LINE_INFO = "LINE_INFO";
export const PRESCRIPTION_TYPE = "PRESCRIPTION_TYPE";
export const CUSTOMER_SELECTED = "CUSTOMER_SELECTED";
export const PHARMACY_SELECTED = "PHARMACY_SELECTED";
export const SET_SYSTEM_CONSTANTS = "SET_SYSTEM_CONSTANTS";
export const EXCLUSION_ERROR_FLAG = "EXCLUSION_ERROR_FLAG";
export const FAMILIES_DATA = "FAMILIES_DATA";
export const PRESCRIPTION_DIRECTOR = "PRESCRIPTION_DIRECTOR";
export const PRESCRIPTION_RESERVATION = "PRESCRIPTION_RESERVATION";
export const APPLY_PRESCRIPTION_INFO = "APPLY_PRESCRIPTION_INFO";
export const APPLY_PRESCRIPTION_ENTER_TYPE = "APPLY_PRESCRIPTION_ENTER_TYPE";


// LINE情報
export function setLineInfo(lineInfo) {
  return { type: LINE_INFO, lineInfo };
}
// システム定数
export function setSystemConstants(systemConstants) {
  return { type: SET_SYSTEM_CONSTANTS, systemConstants };
}
// 排他エラー
export function setExclusionErrorFlag(exclusionErrorFlag) {
  return { type: EXCLUSION_ERROR_FLAG, exclusionErrorFlag };
}
// 家族情報
export function setFamiliesData(familiesData) {
  return { type: FAMILIES_DATA, familiesData };
}
// 利用者選択
export function setCustomerSelected(customerSelected) {
  return { type: CUSTOMER_SELECTED, customerSelected };
}
// 薬局選択
export function setPharmacySelected(pharmacySelected) {
  return { type: PHARMACY_SELECTED, pharmacySelected };
}
//申込薬局情報
export function setApplyPrescriptionInfo(applyPrescriptionInfo) {
  return { type: APPLY_PRESCRIPTION_INFO, applyPrescriptionInfo };
}
// 処方箋種類選択
export function setPrescriptionType(prescriptionType) {
  return { type: PRESCRIPTION_TYPE, prescriptionType };
}
// 服薬指導選択
export function setPrescriptionDirector(prescriptionDirector) {
  return { type: PRESCRIPTION_DIRECTOR, prescriptionDirector };
}
// 服薬指導予約選択
export function setPrescriptionReservation(prescriptionReservation) {
  return { type: PRESCRIPTION_RESERVATION, prescriptionReservation };
}
//処方箋申込入口
export function setApplyPrescriptionEnterType(applyPrescriptionEnterType){
  return {type: APPLY_PRESCRIPTION_ENTER_TYPE, applyPrescriptionEnterType};
}

